import { useEffect, useMemo, useState } from "react"
import { Button, Table, Select, DatePicker, message, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    room_type_id: undefined | string,
    inDate: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type department = {
    "room_type_id": string,
    "room_type_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        room_type_id: undefined,
        inDate: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [bmData, setBmData] = useState<department[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    // 汇总数据
    const [summaryData, setSummaryData] = useState<any>([])
    const [summaryLoading, setSummaryLoading] = useState<boolean>(false)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (fetchOtherParams.inDate) {
            fetch({ pagination, fetchOtherParams })
        }
    }, [pagination.current])


    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        if (fetchOtherParams.inDate) {
            const p = { ...pagination }
            p.current = 1

            let params: any = _.cloneDeep(fetchOtherParams)
            fetch({ pagination: p, fetchOtherParams: params })

        } else {
            message.error('必须选择在住日期')
        }
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        setSummaryLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        handleDate(params, 'inDate', ['query_start_day', 'query_end_day'])

        axiosTable.get('/keeper/data_report/month_check_in_per/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
                // 汇总数据
                setSummaryData(response.month_check_in_summary)
            }

            setLoading(false)
            setSummaryLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.inDate) {
            params.query_start_day = params.inDate[0].format('YYYY-MM-DD')
            params.query_end_day = params.inDate[1].format('YYYY-MM-DD')

            delete params.inDate
        }

        baseAxiosComplete('/keeper/data_report/month_check_in_per/export', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 数据报表 -> 月入住率报表 */}
        <BreadCrumb position={['管家中心', '月入住率报表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')
                        if (v) {
                            // 查询房型
                            baseAxiosNoInfo('/global/room_type_list_by_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setBmData(res)
                            })

                        } else {
                            setBmData([])
                        }
                    }} />
                </div>
                <Select virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 140 }} placeholder="房型" value={fetchOtherParams.room_type_id} onChange={(v: any) => { handleChange(v, 'room_type_id') }}>
                    {bmData.map((el: any) => (<Option value={el.room_type_id} key={el.room_type_id}>{el.room_type_name}</Option>))}
                </Select>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 230 }} placeholder={["开始日期", "结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="房型" dataIndex="room_type_name" key="room_type_name" />
                <Column title="房间数" dataIndex="room_count" key="room_count" />
                <Column title="房间总天数" dataIndex="room_days" key="room_days" />
                <Column title="空房天数" dataIndex="empty_days" key="empty_days" />
                <Column title="空房率" dataIndex="empty_per" key="empty_per" />
                <Column title="预定天数" dataIndex="reserve_days" key="reserve_days" />
                <Column title="预订率" dataIndex="reserve_per" key="reserve_per" />
                <Column title="入住天数" dataIndex="check_in_days" key="check_in_days" />
                <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
            </Table>
        </div>

        {/* 汇总 */}
        <div className="common-main">
            <h3>汇总</h3>

            <Table loading={summaryLoading} dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="房间数" dataIndex="room_count" key="room_count" />
                <Column title="房间总天数" dataIndex="room_days" key="room_days" />
                <Column title="空房天数" dataIndex="empty_days" key="empty_days" />
                <Column title="空房率" dataIndex="empty_per" key="empty_per" />
                <Column title="预定天数" dataIndex="reserve_days" key="reserve_days" />
                <Column title="预订率" dataIndex="reserve_per" key="reserve_per" />
                <Column title="入住天数" dataIndex="check_in_days" key="check_in_days" />
                <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
            </Table>
        </div>
    </div>)
}